module.exports = __webpack_public_path__ + "img/image (127).cec0bdd5.jpg";